module.exports = __webpack_public_path__ + "static/media/others.8c2d2e85.svg";